const selectCardForm = state => state.cardForm;

export const selectCardFormTokenData = state =>
  selectCardForm(state).tokenData;

export const selectCardFormTokenValidationStatus = state =>
  selectCardForm(state).tokenValidationStatus;

export const selectSavedCard = state => selectCardForm(state).savedCard;

